/* istanbul ignore file */
import defaultReducers from '@plone/volto/reducers';

import downloaddetails from './downloaddetails';

const reducers = {
  ...defaultReducers,
  downloaddetails,
};

export default reducers;
